const TIME_CONSTRAINT_NODE_PREFIX = 'time-constraint-node:';

export const toTimeConstraintNodeId = (timeConstraintId: string): string =>
  `${TIME_CONSTRAINT_NODE_PREFIX}${timeConstraintId}`;

export const parseTimeConstraintIdFromNodeId = (
  nodeId: string
): string | null => {
  if (!nodeId.startsWith(TIME_CONSTRAINT_NODE_PREFIX)) {
    return null;
  }

  return nodeId.slice(TIME_CONSTRAINT_NODE_PREFIX.length);
};
